<template>
  <q-td
    class="relative overflow-hidden cursor-pointer !min-w-[120px] group"
    :class="{
      '!border-t-2 border-solid !border-t-neutral-100':
        value.index === 0 && value.current_month,
      'cursor-not-allowed': value.disable,
    }"
  >
    <div
      class="absolute z-[1] inset-0 m-0 size-[200%] pointer-events-none"
      :class="{
        'bg-neutral-10/30': value.current_month,
      }"
    />
    <div
      v-if="haveError"
      class="absolute z-[1] inset-0 m-auto size-full pointer-events-none border-alert-error rounded-md bg-alert-error-10 overflow-hidden | transition-colors group-focus-within:border-2"
    />

    <q-field
      v-if="editingCellKey === value.key && !value.disable"
      v-focus-select
      :model-value="FValue(value.value)"
      class="[--input-size:2.25rem]"
      @update:model-value="
        (e) => {
          // console.log('emit', e)
          emit('update:field', {
            ...value,
            value: e,
            field: key,
          })
          validacoesCampos(e)
        }
      "
    >
      <template
        #control="{ id, floatingLabel, modelValue, emitValue }"
      >
        <input
          v-show="floatingLabel"
          :id="id"
          v-money-format
          :data-input="value.key"
          :value="modelValue"
          class="q-field__input text-center !h-[2.25rem] relative z-[4]"
          @blur="
            (e) => {
              emitValue(parseBRCurrency(e.target.value))
            }
          "
        >
      </template>
    </q-field>
    <!-- MODO VISUALIZAÇÃO: Wrapper focável com <p> dentro -->
    <div
      v-else
      :tabindex="value.input ? 0 : -1"
      class="size-full relative z-[4] flex items-center justify-center focus:outline-none focus:ring-2 focus:ring-primary-100 focus:ring-inset rounded-sm"
      @focus="emit('edit-cell', value.key)"
    >
      <p class="text-center pointer-events-none">
        {{ FValue(value.value) }}
      </p>
    </div>

    <q-tooltip
      v-if="haveError"
      v-bind="{ ...tooltipProps, hideDelay: 0 }"
      class="max-w-[16.25rem] !py-6"
      :style="{
        border: `1px solid rgba(var(--alert-error), 1)`,
      }"
    >
      <span
        class="absolute size-full block top-0 left-0 m-auto z-[2] overflow-hidden bg-alert-error-10"
      />
      <div class="flex flex-col gap-4">
        <p
          v-for="(error, i) in errorMessages"
          :key="i"
          class="text-headline-3 !text-alert-error !whitespace-break-spaces relative z-[3]"
        >
          <span
            class="size-6 bg-alert-error rounded-full inline-block align-middle ml-4"
          />
          {{ error }}
        </p>
      </div>
    </q-tooltip>
  </q-td>
</template>

<script setup>
import { computed } from 'vue'
import { parseBRCurrency, tooltipProps } from 'js/utils/GLOBAL'

const { value, tds, index, validacoes, valueMap, tableStructure } =
  defineProps({
    value: { type: Object, required: true },
    index: { type: Number, required: true },
    tds: { type: Array, required: true },
    validacoes: { type: Object, required: false },
    editingCellKey: { type: String, default: null },
    valueMap: { type: Map, required: false },
    tableStructure: { type: Object, required: false },
  })

const FValue = (v) => Intl.NumberFormat('pt-BR').format(v)

function validacoesCampos(atual) {
  const previous = tds[index - 1]?.[1]
  const next = tds[index + 1]?.[1]

  const previuosBody = {
    template_id: value.template_id,
    valor_atual: +atual,
    valor_anterior: +previous?.value || 0,
  }
  const nextBody = {
    template_id: next?.template_id || null,
    valor_atual: +next?.value || 0,
    valor_anterior: +atual || 0,
  }

  const cascataBody = value?.validacaocascata_set?.map((item) => {
    return {
      template_id: value.template_id,
      campo: item.campo,
      valor_atual: tableStructure.getValue(item.campo),
      valor_anterior: tableStructure.getPreviousValue(item.campo),
      configId: item.config_id,
    }
  })

  emit('validacoes', {
    previuosBody,
    nextBody,
    configId: value.config_id,
    cascataBody,
  })
}

const errorMessages = computed(() => {
  const a = validacoes[value.key]
    .filter((i) => i.error)
    .map((v) => v.message)
    .filter((i) => !!i)
  return a
})

const haveError = computed(() => {
  return validacoes[value.key]?.some((v) => v.error)
})

// Diretiva para focar e selecionar o texto do input
const vFocusSelect = {
  mounted: (el) => {
    const input = el.querySelector('input')
    if (input) {
      input.focus()
      input.select()
    }
  },
}

const emit = defineEmits(['update:field', 'edit-cell', 'validacoes'])
</script>

<style lang="scss" scoped></style>
